import { JT } from "./jumbotronTokens";

const Eyebrow = ({ children }) => (
  <div style={{ ...JT.type.label, color:JT.text.tertiary, marginBottom:3 }}>{children}</div>
);

// Presentational stake · odds · to-win/result row. Signal Scarcity (PR 3): TO WIN is neutral
// (text.primary) until the parent says the slip is winning via `toWinColor`; the result path
// keeps `color` (the graded identity).
export default function BetCardFooter({ stake, odds, toWin, result, color, toWinColor = JT.text.primary }) {
  return (
    <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-end", marginTop:12 }}>
      <div><Eyebrow>Stake</Eyebrow><div style={{ fontSize:14, fontWeight:800, color:JT.text.secondary }}>{stake}</div></div>
      <div style={{ textAlign:"center" }}><Eyebrow>Odds</Eyebrow><div data-testid="footer-odds" style={{ ...JT.display900, fontSize:34, lineHeight:1, color }}>{odds}</div></div>
      <div style={{ textAlign:"right" }}>
        <Eyebrow>{result ? "Result" : "To Win"}</Eyebrow>
        <div data-testid="footer-towin" style={{ ...JT.display900, fontSize:15, color: result ? color : toWinColor }}>{result || toWin}</div>
      </div>
    </div>
  );
}
